import type { Address } from "@covertree/new-business-graphql";

export function formatAddressToString(address: Address) {
  const formattedLotUnit = address.unitNumber
    ?.trim()
    ?.replace(/^([^#])/, "#$1");

  return `${address.streetAddress}${formattedLotUnit ? ", " + formattedLotUnit : ""}, ${address.city}, ${address.state} ${address.zipCode}`;
}
